import type { ReactNode } from 'react';

export const WidgetContainer = ({
  children,
  title,
  action,
}: {
  children: ReactNode;
  title: string;
  action?: ReactNode;
}) => {
  return (
    <div className="h-fit lg:overflow-hidden rounded-lg bg-white p-4 shadow-sm overflow-y-auto">
      <div className="flex items-start justify-between gap-2">
        <dt className="truncate text-xl font-bold text-gray-700">{title}</dt>
        {action}
      </div>
      {children}
    </div>
  );
};
